export const ACTIONS = {
  FETCH_DATA_LOADING: 'FETCH_DATA_LOADING',
  FETCH_EXERCISE_TYPES_SUCCESS: 'FETCH_EXERCISE_TYPES_SUCCESS',
  FETCH_EXERCISE_TYPES_FAILURE: 'FETCH_EXERCISE_TYPES_FAILURE',
  FETCH_EXERCISES_SUCCESS: 'FETCH_EXERCISES_SUCCESS',
  FETCH_EXERCISES_FAILURE: 'FETCH_EXERCISES_FAILURE',
  FETCH_FOOD_SUCCESS: 'FETCH_FOOD_SUCCESS',
  FETCH_FOOD_FAILURE: 'FETCH_FOOD_FAILURE',
  FETCH_GOALS_SUCCESS: 'FETCH_GOALS_SUCCESS',
  FETCH_GOALS_FAILURE: 'FETCH_GOALS_FAILURE',
  ADD_EXERCISE_SUCCESS: 'ADD_EXERCISE_SUCCESS',
  ADD_EXERCISE_FAILURE: 'ADD_EXERCISE_FAILURE',
  ADD_FOOD_SUCCESS: 'ADD_FOOD_SUCCESS',
  ADD_FOOD_FAILURE: 'ADD_FOOD_FAILURE',
  ADD_GOAL_SUCCESS: 'ADD_GOAL_SUCCESS',
  ADD_GOAL_FAILURE: 'ADD_GOAL_FAILURE',
  REMOVE_EXERCISE_SUCCESS: 'REMOVE_EXERCISE_SUCCESS',
  REMOVE_EXERCISE_FAILURE: 'REMOVE_EXERCISE_FAILURE',
  REMOVE_FOOD_SUCCESS: 'REMOVE_FOOD_SUCCESS',
  REMOVE_FOOD_FAILURE: 'REMOVE_FOOD_FAILURE',
  REMOVE_GOAL_SUCCESS: 'REMOVE_GOAL_SUCCESS',
  REMOVE_GOAL_FAILURE: 'REMOVE_GOAL_FAILURE'
};
